(() => {
	angular.module('main').directive('fullDateTime', fullDateTime);

	fullDateTime.$inject = ['timeService', '$http', 'settingsService'];

	function fullDateTime(timeService, $http, settingsService) {
		return {
			restrict: 'E',
			scope: {
				startDate: '<',
				startTime: '<',
				finishDate: '<',
				finishTime: '<'
			},
			template: `<span>
                          <span ng-if="startDate">
                               {{startDate | timeFilter: setStartDateFilter()}}
                            <span ng-show="startDate != finishDate">
                                - <span class="text-nowrap">{{finishDate | timeFilter:'long'}}</span>
                            </span>
                            <span ng-if="startTime">from
                                <span class="text-nowrap">{{convertedStartTime | lowercase}}</span> -
                            <span class="text-nowrap">{{convertedEndTime | lowercase}}</span></span>
                          </span>
                          <span ng-if="!startDate">No date</span>
                       </span>`,
			replace: true,
			transclude: true,
			link(scope) {
				settingsService.timeFormatSettings.subscribe(data => {
					scope.dataTimeFormat = data.timeFormat;
					if (scope.dataTimeFormat === 'T_24') {
						if (scope.startTime && scope.finishTime) {
							scope.convertedStartTime = scope.startTime.slice(0, -3);
							scope.convertedEndTime = scope.finishTime.slice(0, -3);
						}
					} else if (scope.startTime && scope.finishTime) {
						scope.convertedStartTime = timeService.getTimeConvertedTo12(
							scope.startTime
						);
						scope.convertedEndTime = timeService.getTimeConvertedTo12(
							scope.finishTime
						);
					}
				});

				scope.setStartDateFilter = () => {
					const isYearsEqual = timeService.compareYears(
						scope.startDate,
						scope.finishDate
					);
					const isDatesDifferent = timeService.compareDates(
						scope.startDate,
						scope.finishDate
					);

					const onlyYearsAreEqual = isYearsEqual && isDatesDifferent;

					if (onlyYearsAreEqual) {
						return 'dayAndMonth';
					}

					return 'long';
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Filelds/fullDateTime.js